<template>
<div>
<v-container fluid pa-2 >
    <v-card>
            <v-toolbar dense color = "#213c57">             
                <template v-if="$vuetify.breakpoint.smAndDown">
                    <v-col cols="4">
                    <span style = "color:white;font-family:Verdana;font-size: 12px;"> Schedule List :  </span> 
                    <span class="font-weight-black" style="color: yellow;font-family:Verdana;font-size: 13px;"> {{dateToday}} </span>
                    </v-col>
                    <v-col cols="4">
                            <span style = "color:white;font-family:Verdana;font-size: 12px;"> Regular Car :  </span>  
                            <v-icon color="red lighten-2" medium>mdi-flag</v-icon>
                    </v-col>
                    <v-col cols="4">
                        <span style = "color:white;font-family:Verdana;font-size: 12px;"> Special Car :  </span> 
                        <v-icon color="yellow lighten-3" medium>mdi-flag</v-icon>
                    </v-col>
                </template>
                <template v-else>
                    <v-col cols="4">
                    <span style = "color:white;font-family:Verdana;"> Schedule List :  </span> <span class="font-weight-black" style="color: yellow;font-family:Verdana"> {{dateToday}} </span>
                    </v-col>
                    <v-col cols="4">
                            <span style = "color:white;font-family:Verdana"> Regular Car :  </span>  <v-icon color="red lighten-2">mdi-flag</v-icon>
                    </v-col>
                    <v-col cols="4">
                        <span style = "color:white;font-family:Verdana"> Special Car :  </span> <v-icon color="yellow lighten-3">mdi-flag</v-icon>
                    </v-col>
                </template>
            </v-toolbar>
            
</v-card>
</v-container>

<template v-if="$vuetify.breakpoint.smAndDown">
    <v-container fluid id="scroll-target"
    style="max-height: 800px"
    class="overflow-y-auto">

    <v-layout row wrap>
    <v-col cols="12">
      
            <v-card flat width="100%" dense class="mb-2">
                <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in carsRegularReservation" :key="i+'a'" >   
                <template v-for="(r, a) in rec.recs"   >
                <v-card :key="a+'t'" v-if="r.PlateNo !== 'null'"  class="pb-1 pt-0" raised>  
                    <template v-if="$vuetify.breakpoint.smAndDown">                       
                    <v-system-bar height="30" color="red lighten-3">
                        
                        <span class="pl-1 mb-1" style = "font-family:Verdana;font-size:15px;font-weight:bold;color:black">{{rec.timeDisplay}}</span>
                        <v-spacer></v-spacer>
                                
                    
                    </v-system-bar>
                            
                        <v-card color="red lighten-3" tile  v-if="$vuetify.breakpoint.xsOnly">
                                <template v-if="r.recs1[0].designation !== 0">
                                <span  class="mt-0 mb-0 mr-8 ml-3" v-if="r.recs1[0].designation === 1"  style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Seaview -> NAIA</span>
                                <span  class="mt-0 mb-0 mr-10 ml-3" v-if="r.recs1[0].designation === 2"  style = "margin-top:5px;color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Makati Only</span> 
                                <br>
                                </template>
                                <span class="ml-3 mr-10" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">{{r.PlateNo}}  ({{r.recs1[0].typeofCar}})</span>
                
                            <div class="ml-3" style =  "color:black;font-family:Verdana;font-size:14px;font-weight:bold; ">Driver : {{r.recs1[0].Driver}}</div>
                            
                        </v-card> 

                        <v-card color="red lighten-3" tile  v-if="$vuetify.breakpoint.smOnly">
                                <span class="ml-3 mr-8 text-right" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">{{r.PlateNo}}  ({{r.recs1[0].typeofCar}})</span>
                                <template v-if="r.recs1[0].designation !== 0">
                                <span  class="mt-0 mb-0  ml-3" v-if="r.recs1[0].designation === 1"  style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Seaview -> NAIA</span>
                                <span  class="mt-0 mb-0  ml-3" v-if="r.recs1[0].designation === 2"  style = "margin-top:5px;color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Makati Only</span> 
                                </template>
                                <br>
                            <span class="ml-3 mr-3" style =  "color:black;font-family:Verdana;font-size:14px;font-weight:bold; ">Driver : {{r.recs1[0].Driver}}</span>
                          
                            
                        </v-card> 
                        </template>
                        <template v-else>
                        <v-toolbar window lights-out dense color="red lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                            <div>
                            
                            <span  class="mt-0 mb-0 mr-10" style = "font-family:Verdana;font-size:15px;font-weight:bold;color:black ;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                            </div>
                    
                        <template v-if="r.recs1[0].designation !== 0">
                            <span  class="mt-0 mb-0 mr-8" v-if="r.recs1[0].designation === 1"  style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Seaview -> NAIA</span>
                            <span  class="mt-0 mb-0 mr-10" v-if="r.recs1[0].designation === 2"  style = "margin-top:5px;color:black;font-family:Verdana;font-size:14px;font-weight:bold;">Makati Only</span>
                        </template>
                        
                            <span class="ml-2 mr-10" style = "color:black;font-family:Verdana;font-size:14px;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}})</span>
                        <v-row>
                        
                        <v-col cols="12">                  
                        <div style =  "color:black;font-family:Verdana;font-size:14px;font-weight:bold; ">Driver : {{r.recs1[0].Driver}}</div>
                
                        </v-col>      
                        </v-row>
                        
                        </v-toolbar>  
                        </template>
                        <v-card-text>     
                                            
                        
                            <v-layout row  class="ma-0 pa-0" >
                            <v-col   class="pt-0 pb-0" >                                                     
                                                    <p class="subtitle-1 black--text" style = "font-family:Verdana;font-weight:bold">
                                                
                                                <template v-for="(per, k) in r.recs1">
                                                    <v-tooltip bottom :key="k+'c'" color="grey darken-3" transition="slide-y-transition" >
                                                    <template v-slot:activator = "{on}">
                                                    <v-chip :key="k+'c'" small   style = "color:black; font-family:Verdana;font-size:14px"                           
                                                        v-on = "on" >
                                                        {{per.EmpName}} 
                                                    </v-chip>
                                                    </template>        

                                                    <span style="font-family:Verdana;color:white;font-weight:bold; text-align: justify">NAME   : {{per.EmpName}}<br>
                                                                                PICKUP : {{per.pickupName}}<br>
                                                                                ADDRESS  : {{per.DropPoint}}<br>
                                                                                RESIDENCE  : {{per.DropPointDetails}}<br>
                                                                                CELLPHONE  : {{per.phoneNumber}}
                                                        </span>
                                                    </v-tooltip>
                                                    </template>                  
                                                    </p>         
                                            </v-col>
                    
                        </v-layout>
                            
                    </v-card-text>
                    
                        </v-card> 
                        
                        </template>
                </v-col>  
                 
            </v-card>
            <v-card  flat width="100%" class="mb-2"> 
                  <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in carsSpecialReservation1" :key="i+'a'" >
              <!-- Special Cars -->
                    <template v-for="(r, a) in rec.recs">
                    <v-card :key="a+'t'" style="padding-top :0px; padding-bottom :0px" >                         
                        
                        
                          
                            <template v-if="$vuetify.breakpoint.smAndDown">
                              <v-system-bar  height="40" color="yellow lighten-3">
                          
                    
                          <span class="mt-0 mb-0 mr-10 ml-0" style = "color:black;font-family:Verdana;font-size:15px;font-weight:bold;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                                  <v-spacer></v-spacer>
                        
                          
                          
                            
                              </v-system-bar>
                            <v-card color="yellow lighten-3"  v-if="$vuetify.breakpoint.xsOnly">
                            
                            <template v-if="r.PlateNo !== 'null'">
                            
                            <span  class = "mr-8 ml-5 text-sm-left" style = "color:black;font-family:Verdana; font-size:16px;font-weight:bold;">{{r.PlateNo}} ({{r.recs1[0].typeofCar}})</span><br>
                            <span class = "mr-8 ml-5 text-sm-left" style =  "color:black;font-family:Verdana;font-weight:bold;font-size:12px; "> Driver : {{r.recs1[0].Driver}} 
                        </span>
                            </template><br>
                            <span  class=" ml-5 text-sm-left" style =  "color:black;font-family:Verdana;font-size:12px;font-weight:bold; ">Reserved by : {{r.recs1[0].R_Name}} <br>
                            <span class=" ml-5 text-sm-left" v-if="!r.recs1[0].EventVenue" style ="color:black;font-family:Verdana;font-size:12px;">
                              <span v-if="r.recs1[0].Remarks == 'Others'"> Purpose : {{r.recs1[0].Remarks}} - {{r.recs1[0].OtherRemarks}} / {{r.recs1[0].DropPoint}} </span>
                                <span v-else>Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].DropPoint}}</span>
                            </span>
                            <span  class=" ml-5 text-sm-left" v-else style ="color:black;font-family:Verdana;font-size:13px;">Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].EventVenue}} /{{r.recs1[0].DropPoint}} </span></span>
                          
                            </v-card>
                            <v-card color="yellow lighten-3"  v-if="$vuetify.breakpoint.smOnly">
                            
                            <template v-if="r.PlateNo !== 'null'">
                            <span  class = "mr-8 ml-5 text-sm-left" style = "color:black;font-family:Verdana; font-size:16px;font-weight:bold;">{{r.PlateNo}} ({{r.recs1[0].typeofCar}})</span><br>
                            <span class = "mr-8 ml-5 text-sm-left" style =  "color:black;font-family:Verdana;font-weight:bold;font-size:12px; "> Driver : {{r.recs1[0].Driver}} 
                            <!-- <span class = "mr-8 ml-5 text-sm-left" style ="color:black;font-family:Verdana;font-size:13px;">Contact : {{r.recs1[0].driverContacts}}</span> -->
                        </span>
                            </template><br>
                            <span  class=" ml-5 text-sm-left" style =  "color:black;font-family:Verdana;font-size:12px;font-weight:bold; ">Reserved by : {{r.recs1[0].R_Name}}
                            <span class=" ml-5 text-sm-left" v-if="!r.recs1[0].EventVenue" style ="color:black;font-family:Verdana;font-size:12px;">
                              <span v-if="r.recs1[0].Remarks == 'Others'"> Purpose : {{r.recs1[0].Remarks}} - {{r.recs1[0].OtherRemarks}} / {{r.recs1[0].DropPoint}} </span>
                                <span v-else>Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].DropPoint}}</span>
                                </span>
                            
                            <span  class=" ml-5 text-sm-left" v-else style ="color:black;font-family:Verdana;font-size:13px;">Purpose : {{r.recs1[0].Remarks}}  / {{r.recs1[0].EventVenue}} /{{r.recs1[0].DropPoint}} </span></span>
                          
                            </v-card>

                        
                      </template>    

                          <template v-else>
                            <v-toolbar window lights-out dense color="yellow lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                            <div>
                        
                            <span class="mt-0 mb-0 mr-10" style = "color:black;font-family:Verdana;font-size:15px;font-weight:bold;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </span>
                            </div>

                            
                          <v-row>
        
                            <template v-if="r.PlateNo !== 'null'">
                            <span  class = "mr-8 " style = "color:black;font-family:Verdana; font-size:adjustFontSize;font-weight:bold;">{{r.PlateNo}} <br> ({{r.recs1[0].typeofCar}})  </span>
                            <span class = "mr-8" style =  "color:black;font-family:Verdana;font-weight:bold;font-size:13px; "> Driver : {{r.recs1[0].Driver}} 
                            <!-- <span style ="color:black;font-family:Verdana;font-size:14px;">Contact : {{r.recs1[0].driverContacts}}</span> -->
                        </span>
                            </template>
                            <span style =  "color:black;font-family:Verdana;font-size:14px;font-weight:bold; ">Reserved by : {{r.recs1[0].R_Name}} <br>
                            <span v-if="!r.recs1[0].EventVenue" style ="color:black;font-family:Verdana;font-size:13px;">
                              <span v-if="r.recs1[0].Remarks === 'Others'"> Purpose : {{r.recs1[0].Remarks}} - {{r.recs1[0].OtherRemarks}} / {{r.recs1[0].DropPoint}} </span>
                                <span v-else>Purpose : {{r.recs1[0].Remarks}} / {{r.recs1[0].DropPoint}}</span>  </span>
                            <span v-else style ="color:black;font-family:Verdana;font-size:13px;">Purpose : {{r.recs1[0].Remarks}}  / {{r.recs1[0].EventVenue}} /{{r.recs1[0].DropPoint}} </span></span>
                          </v-row>
                          <v-spacer></v-spacer>
                        
                      
                        </v-toolbar>  
                        </template>
                        <v-card-text >      
                            <template v-for="(per, k) in r.recs1">
                              <v-tooltip bottom :key = "k" color="grey darken-3" transition="slide-y-transition">
                                <template v-slot:activator = "{on}">
                                <v-chip :key="k+'c'" small  class="body-1 black--text ma-1 " style = "color:black; font-family:Verdana;"                      
                                     v-on = "on" >
                                    {{per.EmpName}} 
                                </v-chip>
                                </template>        

                                <span style="color:white;font-weight:bold; text-align: justify;font-family:Verdana">NAME   : {{per.EmpName}}<br>
                                                          PICKUP : {{per.pickupName}}<br>
                                                          ADDRESS  : {{per.DropPoint}}<br>
                                                          RESIDENCE   : {{per.DropPointDetails}}<br>
                                                          CELLPHONE  : {{per.localNumber}}
                                  </span>
                                </v-tooltip>
                              

                              </template>                  
                        </v-card-text>                        
                      </v-card> 
                    </template>
                  </v-col>
                </v-card>    
        </v-col>
        </v-layout>
    </v-container>
</template>
<template v-else>
    <v-container fluid id="scroll-target"
    style="max-height: 800px"
    class="overflow-y-auto">

    <v-layout row wrap>
    <v-col cols="12">

            <v-card flat width="100%">
                <v-col class="pb-0 pt-0" cols="12" v-for="(rec, i) in carsReservationDataNew" :key="i+'a'" >
                    <v-card   v-if="!rec.SpecialReq" style = "border: 1px solid grey;margin-bottom:1px" >
                    
                        <v-system-bar  window dense color="red lighten-3" style="padding-top:0px ; padding-bottom:0px ;">
                    
                    <div class="ml-0 mb-1" style = "color:black;font-family:Calibri;font-size:18px;padding-top:0px; padding-bottom:0px;">{{rec.timeDisplay}} </div>
                        </v-system-bar>                   
                    <v-card-text>
                        <template v-for="(r, j) in rec.recs" cols="12"  >
                                    <v-layout row :key="j+'b'" class = "ma-0 " style="margin-bottom :-25px">

                                        <v-row style="margin-bottom: -10px; margin-top: -5px" class="pt-0; pb-0" cols="4"  >
                                                
                                            
                                            <v-col cols="3" class="pt-0 pb-2" >
                                                <template v-if = "!r.PlateNo || r.PlateNo === 'null'">
                                                        <span  class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" >
                                                        ---                                                    
                                                    </span>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if= "r.designation == 1"  class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" > 
                                                            {{r.PlateNo}}  Seaview -> NAIA <br> <span style="color:orangered">{{r.Driver}}</span> <br>
                                                        </span>
                                                        <span v-else-if= "r.designation == 2"  class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" > 
                                                            {{r.PlateNo}}  Makati <br> <span style="color:orangered"> {{r.Driver}}</span><br> 
                                                        </span>
                                                            <span v-else  class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" > 
                                                            {{r.PlateNo}} <br> <span style="color:orangered"> {{r.Driver}}</span>
                                                        </span>
                                                    </template>

                                            </v-col>
                                                    
                                                    <!-- <template v-if="j === 0">

                                                        <span class="body-1 black--text" style = "font-family:Calibri;font-weight:bold">

                                                            PICK UP:

                                                        </span>

                                                    </template> -->

                                                <v-col cols="2" class="pt-0 pb-2">
                                                    <template v-if="j === 0">

                                                        <span class="body-1 black--text" style = "font-family:Calibri;font-weight:bold">

                                                            PICK UP:

                                                        </span>

                                                    </template>
                                            </v-col>       

                                            <v-col cols="7" class="pt-1 pb-2">
                                                
                                                    
                                                    
                                                <v-row class="pt-0 pb-0" v-for="(per, k) in r.recs1"  :key="k+'c'" style="margin-bottom:-25px; margin-top: -15px">
                                                    <v-col cols="4" >
                                                    <p class="body-1 black--text" style = "font-family:Calibri;font-weight:bold; ">

                                                        {{per.pickupName}} 

                                                    </p>
                                                    </v-col>
                                                        <v-col cols="4">
                                                
                                                        <v-row v-for="(s, k) in per.persons"  :key="k+'z'" style="margin-bottom:-15px">
                                                                
                                                                <p  class="body-1 black--text" style = "font-family:Calibri;font-weight:bold " >
                                                                        
                                                                {{s.EmpName}} 

                                                                </p>
                                                                
                                                    </v-row>
                                                </v-col>  
                                                    </v-row>
                                                
                                            </v-col>        
                                        </v-row>
                                            
                                    </v-layout>
                                    <v-divider :key="r.plateNo" style="margin-top:10px; margin-bottom:10px; color:black" ></v-divider> 
                                    <!-- <hr/> -->
                            </template>
                            
                        </v-card-text>
                    
                    </v-card>     

            <!-- Special Cars -->

                    <v-card v-else style = "border: 1px solid grey; margin-bottom:1px" >
                    <v-system-bar window dense  color="yellow lighten-3" class="pt-0 pb-0" >
                        <!-- <div class="pl-4 headline mb-1"> -->

                            <v-row>
                                <v-col cols = "2">
                                    <span class="ml-0 mb-1" style = "color:black;font-family:Calibri;font-size:18px;">{{rec.timeDisplay}} </span> 
                                </v-col>

                                <v-col cols = "4">
                                <span  style = "color:black;font-family:Calibri;font-size:18px;">  Purpose: {{rec.Remarks}} </span>
                                <span style = "color:black;font-family:Calibri;font-size:18px;" v-if="rec.Remarks === 'Others'"> - {{rec.OtherRemarks}}</span>
                                </v-col>

                                    <v-col cols = "6">
                                    <span style = "color:black;font-family:Calibri;font-size:18px;">  Reserved By:    {{rec.R_Name}} </span>
                                </v-col>
                            </v-row>
                                
                        </v-system-bar>  

                        <v-card-text>
                        <template v-for="(r, j) in rec.recs" cols="12"  >
                                    <v-layout row :key="j+'b'" class = "ma-0 " style="margin-bottom :-25px">

                                        <v-row style="margin-bottom: -10px; margin-top: -5px" class="pt-0; pb-0" cols="4"  >
                                                
                                            <v-col cols="3" class="pt-1 pb-2" style="margin-bottom:-5px">
                                            
                                                
                                                    <p v-if = "!r.PlateNo || r.PlateNo == 'null'" class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" >
                                                        ---                                                    
                                                    </p >  

                                                    <p v-else class="body-1" style="color:blue; font-family:Calibri;font-weight:bold" >                                                 
                                                        
                                                        {{r.PlateNo}} <br> <span style="color:orangered"> {{r.Driver}}  </span> 
                                                        
                                                        <!-- {{per.PlateNo}}     -->                
                                                    </p >                                                                                                                                                                                                   
                                                
                                            </v-col>

                                            <v-col cols="2" class="pt-1 pb-2" >

                                                    <template v-if="j === 0">

                                                        <p class="body-1 black--text" style = "font-family:Calibri;font-weight:bold">

                                                            PICK UP:

                                                        </p>

                                                    </template>

                                            </v-col>

                                            <v-col cols="7" class="pt-1 pb-2">
                                                    
                                                <v-row class="pt-0 pb-0" v-for="(per, k) in r.recs1"  :key="k+'j'" style="margin-bottom:-25px; margin-top: -15px">
                                                    <v-col cols="4" >
                                                    
                                                    <p v-if = "per.pickupName === 'null'" class="body-1 black--text" style = "font-family:Calibri;font-weight:bold; ">
                                                        
                                                    </p> 

                                                    <p v-else class="body-1 black--text" style = "font-family:Calibri;font-weight:bold; ">
                                                            {{per.pickupName}} 
                                                    </p>

                                                    </v-col>
                                                        <v-col cols="4">
                                                
                                                        <v-row v-for="(s, k) in per.persons"  :key="k+'k'" style="margin-bottom:-15px">
                                                                
                                                                <p  class="body-1 black--text" style = "font-family:Calibri;font-weight:bold " >
                                                                        
                                                                {{s.EmpName}} 

                                                                </p>
                                                                
                                                    </v-row>
                                                </v-col>     
                                                
                                                    
                                                    </v-row>
                                                
                                            </v-col>
                                            <!-- <v-col cols="5" class="pt-1 pb-2" >
                                                    

                                            </v-col>
                                            -->
                                            
                                            
                                        </v-row>
                                            
                                    </v-layout>
                                    <v-divider :key="r + 'r'" style="margin-top:10px" ></v-divider> 
                                    <!-- <hr/> -->
                            </template>
                            
                        </v-card-text>

                    
                </v-card>

                </v-col>
            </v-card>

                
        </v-col>
</v-layout>
        </v-container>
</template>
 
</div>
</template>



<script>

// import axios from 'axios'
import api from '../api.js'
import moment from 'moment'
export default {

data() {
    return {
        carsReservationData: [],
        dateToday : moment().format("YYYY-MM-DD"),
        carsReservationDataNew :[],
        carsRegularReservation : [],
        carsSpecialReservation : []
    }
},

created() {

//   this.loadCarsData()
    this.loadCarsDataNew()
    this.loadAllReservation()
    this.$EventBus.$on('SendCarUpdate',()=>{  
        this.loadCarsDataNew()
        this.loadAllReservation()
    })

},
methods:{
    loadCarsDataNew(){
        const url = `${this.api}viewReservation/${this.dateToday}`
        api.get(url).then(res=>{
            this.carsReservationDataNew = res.data.sort((a,b) => (a.timeDisplay > b.timeDisplay) ? 1 : ((b.timeDisplay > a.timeDisplay) ? -1 : 0))

        })
    },
    promiseGetEmployeeInfo( employeeId ) {
      return new Promise((resolve,reject) => {
          const url = `${this.api}getUsers/${employeeId}`
          api.get(url).then(res=>{
             if( res.data ) {
                resolve(res.data)
             }
          })
          .catch(err=>{
            reject({ message: err.message })
          })
      })
    },
    loadAllReservation(){
        let url = `${this.api}AllReservation/${this.dateToday}`
        api.get(url).then( async res =>{
        this.carsRegularReservation = res.data[0]
        this.carsSpecialReservation = res.data[1]

        let tmpCarsSpecial = res.data[1].map( async rec=>{  // 2022-11-08
            let resevationList = rec.recs[0].recs1
            resevationList.map( async item =>{
                let objData = await this.promiseGetEmployeeInfo( item.empId )
                
                item.DropPoint = objData.DropPoint
                item.DropPointDetails = objData.DropPointDetails
                
                    item.localNumber =  objData.phoneNumber != undefined? objData.phoneNumber : '---'
                
                
                return item
            })
            return rec
        })
        this.carsSpecialReservation = await Promise.all( tmpCarsSpecial )
            
      })

    },
},
computed:{
    carsSpecialReservation1(){
      return this.carsSpecialReservation
    },
}

}

</script>

<style>

.rounded-card{

border-radius: 50px;

}

</style>